module.exports = __webpack_public_path__ + "img/combat-shoe.bae7974b.png";